import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { DatePicker } from "@mui/lab";
import { Button, Drawer, Stack, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React, { useState } from "react";
import TextareaAutosize from "@mui/material/TextareaAutosize";

const useStyles = makeStyles(() => ({
  root: {
    flexShrink: 0,
  },
  date1: { border: "1px solid red" },
}));

function Customer({
  open,
  rowCustomer,
  SaveChanges,
  onClose,
}: {
  open: boolean;
  rowCustomer: any;
  SaveChanges: any;
  onClose: any;
}) {
  const classes = useStyles();
  const [openDrawer, SetOpenDrawer] = React.useState<any>(open);
  const [tag, SetTag] = React.useState<any>("");
  const [currentRow, SetCurrentRow] = useState([] as any);
  const [value, setValue] = React.useState(new Date());

  const handleChange = (newValue: any) => {
    setValue(newValue);
  };

  function OnSaveClick() {
    SaveChanges(currentRow);
  }
  React.useEffect(() => {
    if (open == true) {
      const cloneRow = { ...rowCustomer };
      // if (cloneRow.dateLive != null) {
      //   const d = new Date(cloneRow.dateLive);
      //   d.setMinutes(d.getMinutes() + new Date().getTimezoneOffset());
      //   cloneRow.dateLive = d;
      // }
      SetCurrentRow(cloneRow);
    }
    SetOpenDrawer(open);
  }, [open]);

  function SetValue(key: string, value: any) {
    currentRow[key] = value;
    SetTag(new Date().getMilliseconds());
  }

  return (
    <Box>
      <Drawer
        PaperProps={{ style: { width: "auto" } }}
        anchor="right"
        open={openDrawer}
        onClose={() => onClose(0)}
        variant={"temporary"}
      >
        <Box style={{ padding: "5px 10px", marginTop: "15px" }}>
          <Box style={{ width: "100%" }}>
            <Box>
              <TextField
                disabled
                required
                id="outlined-required"
                label="Dealer Name"
                value={currentRow.name}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                disabled
                required
                id="outlined-required"
                label="Serial Number"
                value={currentRow.serialNumber}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                disabled
                required
                id="outlined-required"
                label="DB Server"
                value={currentRow.dbserver}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                disabled
                required
                id="outlined-required"
                label="WVD Server"
                value={currentRow.wvdserver}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["year", "month", "day"]}
                  className={classes.date1}
                  label="Date Live"
                  value={currentRow.dateLive}
                  onChange={(newvalue: any) => {
                    SetValue("dateLive", newvalue);
                  }}
                  renderInput={(params: any) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                id="outlined-required"
                label="Email"
                defaultValue={currentRow.email}
                onChange={(e: any) => {
                  SetValue("email", e.target.value);
                }}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                id="outlined-required"
                label="Phone"
                defaultValue={currentRow.phone}
                onChange={(e: any) => {
                  SetValue("phone", e.target.value);
                }}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "12px" }}>
              <TextareaAutosize
                required
                aria-label="minimum height"
                minRows={3}
                defaultValue={currentRow.notes}
                placeholder="Notes"
                onChange={(e: any) => {
                  SetValue("notes", e.target.value);
                }}
                style={{ width: 300, height: 100 }}
              />
            </Box>

          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{ padding: "10px", border: "0px solid red" }}
          >
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={OnSaveClick}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
export default Customer;
